import React, { Component } from 'react';
import { firebaseApp } from '../../firebase'
import Loader from 'react-loader-spinner'
import 'firebase/firestore'
import ajax from '../../ajax'

export default class CreateUser extends Component {
	constructor() {
		super()

		this.state = {
			email: '',
			password: '',
			spinner: false,
			business: '',

		}

		this.handleSubmit = this.handleSubmit.bind(this)
	}

	firebaseRef =  firebaseApp.database().ref('locations')
  firestoreDb = firebaseApp.firestore()

	async handleSubmit(e) {

		e.persist();
		e.preventDefault();

		let formData = {}
		for(const field in this.refs){
			formData[field] = this.refs[field].value
		}
		const randomPassword = Math.random().toString(36).slice(2,10);
		formData.password = randomPassword;
		formData.loginType = 'vendor';

		let options = {
			method: "Post",
			body: JSON.stringify({
				business: formData
			})
		}
		let url = "https://us-central1-funily-deals.cloudfunctions.net/createUser";

		this.setState({
				spinner: true,
				email: formData.email,
				password: randomPassword,
				business: formData.business
			}, async () => {

			try {

				let createUser = await fetch(url,options);
				let jsonRes = await createUser.json();

				this.setState({spinner: false}, () => {
					console.log(jsonRes);
				})

			} catch (e) {
				this.setState({spinner: false});
				throw e;
			}

		})


		e.target.reset();
	}

	render() {
		return (
			<div className='col-md-8 col-md-offset-2' style={styles.container}>
				<div style={{flex: 1}}>
					<form onSubmit={this.handleSubmit}>
						<div className='form-group'>
						<input className='form-control' type='text' ref='business' placeholder='Business Name'  />
						</div>
						<div className='form-group'>
						<input className='form-control' type='text' ref='manager' placeholder='Manager or Owner Name'  />
						</div>
						<div className='form-group'>
						<input className='form-control' type='text' ref='address' placeholder='Enter Business Addresss'  />
						</div>
						<div className='form-group'>
						<input className='form-control' type='text' ref='phone' placeholder='Business Phone | ex. 800-123-4567'  />
						</div>
						<div className='form-group'>
						<input className='form-control' type='email' ref='email' placeholder="Email"  />
						</div>
						<button className='btn btn-info btn-block' type='submit'>Add Business</button>
					</form>
					{
				      this.state.spinner ? <div className='text-center'><Loader
				                               type="Ball-Triangle"
				                               color="#00BFFF"
				                               height="100"
				                               width="100"
				                            />
				                            </div>
				                          : null
				    }
					<h1 className='text-center'>{this.state.email} </h1>
					<h1 className='text-center'>{this.state.password} </h1>
				</div>
			</div>
		);
	}
}


const styles = {
	container: {
		display: 'flex',
		justifyContent: "center",
		paddingTop: "20px",
		marginTop: 200
	}
}



// WEBPACK FOOTER //
// ./src/components/admin/CreateUser.js